import { render, staticRenderFns } from "./Attachpackageitem.vue?vue&type=template&id=0b861aa4&v-on-clickaway=cancel&"
import script from "./Attachpackageitem.vue?vue&type=script&lang=ts&"
export * from "./Attachpackageitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports